// extracted by mini-css-extract-plugin
export default {"MasterDeckSlotStyle":"master-deck-slot_MasterDeckSlotStyle__-Siui","MasterPlaceholder":"master-deck-slot_MasterPlaceholder__flMn9","spin":"master-deck-slot_spin__J5h4B"};